export default __webpack_public_path__ + "static/media/07.4b408b41.jpg";